import React from "react";
import { Grid, makeStyles } from "@material-ui/core";
import EventBusyIcon from "@material-ui/icons/EventBusy";
import IconButton from "@material-ui/core/IconButton";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";

const useStyles = makeStyles(theme => ({
  unscheduledWrapper: {
    padding: theme.spacing(1, 2, 1, 3),
    backgroundColor: "rgba(217, 48, 36, 0.08)",
    borderBottom: "1px solid rgba(217, 48, 36, 0.08)",
    cursor: "pointer"
  }
}));

const UnscheduledBar = props => {
  const { unassigned, warnReopen } = props;

  // General
  const classes = useStyles();

  return (
    <>
      {unassigned.length > 0 && (
        <Grid
          container
          className={classes.unscheduledWrapper}
          alignItems="center"
          onClick={() => {
            warnReopen("unscheduled");
          }}
        >
          <Grid item>
            <EventBusyIcon style={{ color: "#D93024", paddingTop: 8 }} />
          </Grid>
          <Grid
            item
            style={{
              marginLeft: 20,
              color: "#A9362E",
              fontSize: 14,
              fontWeight: 500
            }}
            xs
          >{`${unassigned.length} stops were unscheduled`}</Grid>
          <Grid item>
            <IconButton>
              <KeyboardArrowRightIcon
                style={{
                  color: "#A9362E"
                }}
              />
            </IconButton>
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default UnscheduledBar;
